import { render, staticRenderFns } from "./animation-svg.vue?vue&type=template&id=752b4fb7&scoped=true&"
import script from "./animation-svg.vue?vue&type=script&lang=js&"
export * from "./animation-svg.vue?vue&type=script&lang=js&"
import style0 from "./animation-svg.vue?vue&type=style&index=0&id=752b4fb7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752b4fb7",
  null
  
)

export default component.exports